// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PauseCircleFilledSvg from "@ant-design/icons-svg/es/asn/PauseCircleFilled";
import AntdIcon from '../components/AntdIcon';

var PauseCircleFilled = function PauseCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PauseCircleFilledSvg
  }));
};

PauseCircleFilled.displayName = 'PauseCircleFilled';
export default React.forwardRef(PauseCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PauseCircleFilled.js
// module id = 1539
// module chunks = 0